// SensorData API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type SensorDataRequests = {
    recoveryRequest: RequestConfigFunction<{loggerNumber: string, data: any}>,
}

const sensorDataRequests: SensorDataRequests = {
    recoveryRequest: ({
        loggerNumber,
        data,
    }) => {
        return {
            url: `sensordata/logger/${loggerNumber}/gaps-recalculation`,
            method: 'POST',
            data,
        }
    },
}

export default sensorDataRequests
